/*!
 * (C) Ionic http://ionicframework.com - MIT License
 */
import{i as initialize}from"./ionic-global-c74e4951.js";var globalScripts=initialize;export{globalScripts as g};